const SkeletonThemeProps = ( locale: string) => ({
  UnAuth: {
    baseColor: "#e0e0e0",
    highlightColor: "#b8b8b8",
  },
  Auth: {
    baseColor: "#1f1f1f",
    highlightColor: "#2b2b2b",
  },
});

export default SkeletonThemeProps;
